import React from 'react'
import Layout from '../components/Layout'
import Head from '../components/head'
import Banner from '../components/Banner'
import PostsHome from '../components/PostsHome'
import { graphql, useStaticQuery } from 'gatsby'

const HomePage = () => {
  const data = useStaticQuery(graphql`
        query {
          allMarkdownRemark(limit: 6, sort: {fields: [frontmatter___date], order: DESC}) {
            edges {
              node {
                id
                frontmatter {
                  title
                  date(formatString: "DD/MM/YYYY")
                  image
                  isVisible
                }
                fields {
                  slug
                }
              }
            }
          }
        }
    `)
  return (
    <Layout>
      <Banner />
      <Head title="Home" />
      <PostsHome posts={data.allMarkdownRemark.edges} />
    </Layout>
  )
}

export default HomePage
